function MarketChannelCell(props) {
    return <>{props.value?.label ?? "-"}</>;
}

export default MarketChannelCell;
